[
  {
    "id": 1,
    "type": "text",
    "prompt": "What is the capital of California?",
    "answer": "Sacramento"
  },
  {
    "id": 2,
    "type": "select",
    "prompt": "Which river is the longest?",
    "choices": [
      "Mississippi",
      "Missouri",
      "Colorado",
      "Delaware"
    ],
    "answer": "Missouri",
    "shuffle": true
  },
  {
    "id": 3,
    "type": "checkbox",
    "prompt": "Which presidents are carved into Mount Rushmore?",
    "choices": [
      "A. Jackson",
      "B. Franklin",
      "T. Jefferson",
      "T. Roosevelt"
    ],
    "answer": [
      "T. Jefferson",
      "T. Roosevelt"
    ],
    "shuffle": true
  },
  {
    "id": 4,
    "type": "radio",
    "prompt": "What is the smallest US State?",
    "choices": [
      "Maine",
      "Rhode Island",
      "Maryland",
      "Delaware"
    ],
    "answer": "Rhode Island",
    "shuffle": true
  },
  {
    "id": 5,
    "type": "text",
    "prompt": "Which state is known as the \"Sunshine State\"?",
    "answer": "Florida"
  },
  {
    "id": 6,
    "type": "number",
    "prompt": "How many states are in the United States?",
    "min": 1,
    "max": 100,
    "answer": 50
  },
  {
    "id": 7,
    "type": "range",
    "prompt": "How many Great Lakes are there?",
    "min": 1,
    "max": 10,
    "answer": 5
  },
  {
    "id": 8,
    "type": "datalist",
    "prompt": "In which state is the Grand Canyon located?",
    "choices": [
      "Arizona",
      "Colorado",
      "Nevada",
      "New Mexico",
      "Utah"
    ],
    "answer": "Arizona",
    "shuffle": true
  },
  {
    "id": 9,
    "type": "radio",
    "prompt": "Which ocean borders the west coast of the United States?",
    "choices": [
      "Atlantic",
      "Pacific",
      "Arctic",
      "Indian"
    ],
    "answer": "Pacific",
    "shuffle": true
  },
  {
    "id": 10,
    "type": "checkbox",
    "prompt": "Which of these states border Mexico? (Select all that apply)",
    "choices": [
      "California",
      "Nevada",
      "Arizona",
      "New Mexico",
      "Colorado",
      "Texas"
    ],
    "answer": [
      "California",
      "Arizona",
      "New Mexico",
      "Texas"
    ],
    "shuffle": true
  }
]
